import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RadialMeter from './RadialMeter';
import {OptionType} from "../../types";

export default class StatsRadialMeter extends Component {
    static propTypes = {
        value: PropTypes.number.isRequired,
        totalValue: PropTypes.number.isRequired,
        subValues: PropTypes.arrayOf(OptionType),
        isLoading: PropTypes.bool
    }

    static defaultProps = {
        subValues: null,
        isLoading: false
    }

    constructor(props) {
        super(props);

        this.state = {
            value: 0
        }
    }

    componentDidMount() {
        this.setState({
            value: this.props.value
        })
    }

    renderSubValues() {
        if (this.props.subValues) {
            const subValues = this.props.subValues.map((value, index) =>
                <div className={"stats_subvalue"} key={value.label + "-" + index}>
                    <span className={"subvalue_label"}>{value.label}</span>
                    <span className={"subvalue_value"}>{value.value}</span>
                </div>
            )
            return <div className={"stats_subvalues"}>{subValues}</div>
        } else {
            return null;
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value
            })
        }
    }

    render() {
        return (
            <RadialMeter className={'stats-meter'}
                         value={this.props.isLoading || isNaN(this.state.value / this.props.totalValue) ?
                                 0 : this.state.value / this.props.totalValue}>
                {
                    this.props.isLoading ?
                        <div className="inline-spinner" />
                        :
                        <div>
                            <div className={"stats_value"}>{this.props.totalValue}</div>
                            {this.renderSubValues()}
                        </div>
                }
            </RadialMeter>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/RadialMeter/StatsRadialMeter.jsx